import {useEffect, useRef} from 'react';
import {actionBus, type ActionHandler, type ComponentKey} from '../services/action-bus';

export function useActionListener(
    componentType: ComponentKey,
    handler: ActionHandler
): void {
    const handlerRef = useRef<ActionHandler>(handler);

    useEffect(() => {
        handlerRef.current = handler;
    }, [handler]);

    useEffect(() => {
        return actionBus.subscribe(componentType, (payload) => {
            handlerRef.current(payload);
        });
    }, [componentType]);
}


